import { AxiosResponse } from 'axios';
import { AddressSearchResult } from '../pages/payment-new/components/address-fields/types';
import paymentAPI from 'src/pages/deprecated/payment/api';

export default class AddressService {
  public static async searchAddresses(
    query: string
  ): Promise<AddressSearchResult[]> {
    try {
      const response: AxiosResponse = await paymentAPI.get(
        `/search-address?address=${encodeURIComponent(query)}`
      );
      return response.data || [];
    } catch (error) {
      console.error('Error searching addresses:', error);
      return [];
    }
  }
}
